import React, { useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { addNewSiteContact, showAddNewContactForm } from 'features/order-tracker/store/actions';
import { mapPhoneNumber } from 'features/order-tracker/utils';

import { FormItem } from './components';
import {
  ANALYTICS_APPT_CONTACT_CANCEL,
  ANALYTICS_APPT_CONTACT_SAVE,
  NAME_PATTERN,
  PHONE_NUMBER_INPUT_PATTERN,
} from './constants';
import { inputData } from './inputData';

import styles from './styles.module.scss';

export const NewSiteContactForm: React.FC = () => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    additionalPhoneNumber: '',
    email: '',
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<components.ContactFormData>();

  const onSubmit: SubmitHandler<components.ContactFormData> = ({
    title,
    firstName,
    lastName,
    phone,
    additionalPhoneNumber,
    email,
  }) => {
    const newData = {
      contactKey: `new${Date.now()}`,
      title,
      firstName,
      lastName,
      fullName: `${title} ${firstName} ${lastName}`.trim(),
      email,
      phone,
      additionalPhoneNumber,
    };

    dispatch(addNewSiteContact(newData));
  };

  const cancelHandler = (): void => {
    dispatch(showAddNewContactForm(false));
  };

  const handleChange = (event: { target: HTMLInputElement }) => {
    const {
      target: { value, id },
    } = event;

    if (!value.length) {
      setFormValues({ ...formValues, [id]: '' });
      return;
    }
    switch (true) {
      case /name/i.test(id):
        if (NAME_PATTERN.test(value)) {
          setFormValues({ ...formValues, [id]: value });
          setValue(id as keyof components.ContactFormData, value);
        }
        break;
      case /phone/i.test(id):
        if (PHONE_NUMBER_INPUT_PATTERN.test(value)) {
          setFormValues({ ...formValues, [id]: mapPhoneNumber(value) });
          setValue(id as keyof components.ContactFormData, mapPhoneNumber(value));
        }
        break;
      default:
        setFormValues({ ...formValues, [id]: value });
        setValue(id as keyof components.ContactFormData, value);
    }
  };

  return (
    <form className={styles.contactForm} onSubmit={handleSubmit(onSubmit)}>
      {inputData.map((item) => (
        <FormItem
          key={item.data.id}
          {...item}
          register={register}
          errors={errors}
          handleChange={handleChange}
          value={formValues[item.data.id]}
        />
      ))}
      <div className={styles.newContactButtons}>
        <button data-testid="submit" type="submit" data-analytics-link={ANALYTICS_APPT_CONTACT_SAVE}>
          Add new site contact
        </button>
        <button onClick={cancelHandler} type="button" data-analytics-link={ANALYTICS_APPT_CONTACT_CANCEL}>
          Cancel
        </button>
      </div>
    </form>
  );
};
